/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { List$1 } from "igniteui-react-core";
import { GridColumnSpacer } from "./GridColumnSpacer";
import { markType } from "igniteui-react-core";
/**
 * @hidden
 */
var GridColumnSpacerCollection = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridColumnSpacerCollection, _super);
    function GridColumnSpacerCollection() {
        return _super.call(this, GridColumnSpacer.$, 0) || this;
    }
    GridColumnSpacerCollection.prototype.ac = function () {
        var a = this.count;
        var b = 0;
        for (var c = 0; c < a; c++) {
            b = b + this._inner[c].i;
        }
        return b;
    };
    GridColumnSpacerCollection.prototype.ag = function () {
        var a = this.count;
        var b = 0;
        for (var c = 0; c < a; c++) {
            if (this._inner[c].f) {
                b = b + this._inner[c].i;
            }
        }
        return b;
    };
    GridColumnSpacerCollection.prototype.ae = function () {
        var a = this.count;
        var b = 0;
        for (var c = 0; c < a; c++) {
            if (!this._inner[c].f) {
                b = b + this._inner[c].i;
            }
        }
        return b;
    };
    GridColumnSpacerCollection.prototype.ah = function () {
        var a = this.count;
        var b = 0;
        for (var c = 0; c < a; c++) {
            if (this._inner[c].i > 0) {
                b = b + this._inner[c].j;
            }
        }
        return b;
    };
    GridColumnSpacerCollection.prototype.ad = function (a) {
        var b = this.count;
        var c = 0;
        for (var d = 0; d < b; d++) {
            if (!this._inner[d].d && !(this._inner[d].n == a)) {
                c = c + this._inner[d].i;
            }
        }
        return c;
    };
    GridColumnSpacerCollection.prototype.af = function (a) {
        var b = this.count;
        var c = 0;
        for (var d = 0; d < b; d++) {
            if (this._inner[d].d && !(this._inner[d].n == a)) {
                c = c + this._inner[d].i;
            }
        }
        return c;
    };
    GridColumnSpacerCollection.$t = markType(GridColumnSpacerCollection, 'GridColumnSpacerCollection', List$1.$.specialize(GridColumnSpacer.$));
    return GridColumnSpacerCollection;
}(List$1));
export { GridColumnSpacerCollection };
//# sourceMappingURL=GridColumnSpacerCollection.js.map
